module.exports = __webpack_public_path__ + "static/starting-finishing-8b3c2fcd726c20f8414e3e84aa291ae3.jpg";